import React, { useState } from "react";
import Layout from "@/components/Layout";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import api from "@/lib/api";

export default function Contatti() {
  const [f, setF] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", f);
      toast.success("Messaggio inviato. Ti risponderemo al più presto.");
      setF({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch {
      toast.error("Errore nell'invio. Riprova.");
    } finally {
      setSending(false);
    }
  };

  return (
    <Layout>
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-16 pb-24 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="overline">Contatti</div>
          <h1 className="font-display text-5xl lg:text-6xl leading-[0.95] mt-3">Scrivici.</h1>
          <p className="mt-6 text-[#6B6960] leading-relaxed max-w-md">
            Per informazioni, progetti su misura, o soggiorni particolari. Rispondiamo entro 24 ore lavorative.
          </p>
          <div className="mt-10 space-y-4 text-sm">
            <div><span className="overline block mb-1">Sede</span> Via Miniera 10 · 61029 Urbino (PU) · Italia</div>
            <div><span className="overline block mb-1">Telefono</span> <a href="tel:+393665959253" className="link-underline">+39 366 595 9253</a></div>
            <div><span className="overline block mb-1">Email</span> <a href="mailto:info@cortedellaminiera.it" className="link-underline">info@cortedellaminiera.it</a></div>
            <div><span className="overline block mb-1">Sito ufficiale</span> www.cortedellaminiera.it</div>
            <div className="pt-2">
              <span className="overline block mb-2">Seguici</span>
              <div className="flex gap-3">
                <a href="https://www.instagram.com/cortedellaminiera" target="_blank" rel="noopener noreferrer" className="border border-[#E2DFD6] px-4 py-2 hover:border-[#8C3A27]">Instagram</a>
                <a href="https://www.facebook.com/cortedellaminiera" target="_blank" rel="noopener noreferrer" className="border border-[#E2DFD6] px-4 py-2 hover:border-[#8C3A27]">Facebook</a>
              </div>
            </div>
          </div>
        </div>

        <form onSubmit={submit} className="lg:col-span-7 border border-[#E2DFD6] bg-white p-8 space-y-4" data-testid="contact-form">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div><Label>Nome e cognome</Label><Input required data-testid="contact-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} /></div>
            <div><Label>Email</Label><Input required type="email" data-testid="contact-email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} /></div>
            <div><Label>Telefono</Label><Input data-testid="contact-phone" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} /></div>
            <div><Label>Oggetto</Label><Input required data-testid="contact-subject" value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} /></div>
          </div>
          <div><Label>Messaggio</Label><Textarea required rows={6} data-testid="contact-message" value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} /></div>
          <Button type="submit" disabled={sending} data-testid="contact-submit" className="btn-primary-cdm rounded-full h-11 px-7">{sending ? "Invio…" : "Invia messaggio"}</Button>
        </form>
      </section>
    </Layout>
  );
}
